import { api } from './api'

const apiVersion = 'v2'

export const ratesApi = api
    .enhanceEndpoints({
        addTagTypes: ['Rates'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getRates: builder.query({
                query: ({ organisationId }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/rate-tables/rates`,
                }),
                transformResponse: (response) => {
                    delete response.$type

                    return response
                },
                providesTags: (result, _error, _arg) =>
                    result
                        ? [
                              ...(Object.keys(result).map((rateId) => ({ type: 'Rates', id: rateId })) ?? []),
                              { type: 'Rates', id: 'LIST' },
                          ]
                        : [{ type: 'Rates', id: 'LIST' }],
            }),
        }),
    })

export const { useGetRatesQuery } = ratesApi
